import noop from '@tinkoff/utils/function/noop';

import {useEffect} from 'react';
import {useEventCallback} from 'usehooks-ts';

import {isMobilePWA} from 'utils/user_agent';
import {usePushSubscription} from '../use_push_subscription';

type Props = {
    setNotificationsPermissionRequested: (value: boolean) => void;
    wasNotificationsPermissionRequested: boolean;
}

export const NotificationsPermissionRequestIfNeeded = ({
    wasNotificationsPermissionRequested,
    setNotificationsPermissionRequested,
}: Props) => {
    const {subscribe} = usePushSubscription();

    const handleNotificationsPermissionRequest = useEventCallback(() => {
        if (wasNotificationsPermissionRequested) {
            return;
        }

        subscribe();
        setNotificationsPermissionRequested(true);
    });

    useEffect(() => {
        if (!isMobilePWA()) {
            return noop;
        }

        document.addEventListener('click', handleNotificationsPermissionRequest, {once: true});

        return () => {
            document.removeEventListener('click', handleNotificationsPermissionRequest);
        };
    }, [handleNotificationsPermissionRequest]);

    return null;
};
